import React from 'react';
import { CommentCard } from './CommentCard';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ErrorMessage } from '../common/ErrorMessage';
import type { Comment } from '../../types/comment';
import { useLanguage } from '../../i18n/useLanguage';

interface CommentListProps {
  comments: Comment[];
  loading?: boolean;
  error?: string | null;
  onEdit?: (comment: Comment) => void;
  onDelete?: (commentId: string) => void;
  onRefresh?: () => void;
  postAuthorId?: string;
  onMessageAuthor?: (comment: Comment) => void;
  /** When false and there are no comments, the empty-state copy is omitted (e.g. parent shows login CTA). */
  isAuthenticated?: boolean;
}

export const CommentList: React.FC<CommentListProps> = ({
  comments,
  loading = false,
  error = null,
  onEdit,
  onDelete,
  onRefresh,
  postAuthorId,
  onMessageAuthor,
  isAuthenticated = true,
}) => {
  const { t } = useLanguage();
  if (loading) {
    return (
      <div className="comment-list">
        <LoadingSpinner size="medium" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="comment-list">
        <ErrorMessage message={error} />
      </div>
    );
  }

  if (comments.length === 0) {
    if (!isAuthenticated) {
      return null;
    }
    return (
      <div className="comment-list">
        <p className="comment-list-empty">
          {t('comment.noneYet')} <a href="#comment-form">{t('comment.addLink')}</a>.
        </p>
      </div>
    );
  }

  return (
    <div className="comment-list">
      {comments.map((comment) => (
        <CommentCard
          key={comment.id}
          comment={comment}
          onEdit={onEdit}
          onDelete={onDelete}
          onRefresh={onRefresh}
          onFlagged={onRefresh}
          postAuthorId={postAuthorId}
          onMessageAuthor={onMessageAuthor}
        />
      ))}
      {isAuthenticated && (
        <p className="comment-list-add">
          <a href="#comment-form">{t('comment.addLink')}</a>
        </p>
      )}
    </div>
  );
};

